'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{ background: 'var(--mamba-black)' }}
    >
      <div className="text-center max-w-md">
        <div
          style={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 900,
            fontSize: '120px',
            lineHeight: 1,
            color: 'rgba(107,33,168,0.15)',
            marginBottom: '24px',
          }}
        >
          404
        </div>
        <h2
          style={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 800,
            fontSize: '28px',
            color: 'var(--white)',
            marginBottom: '12px',
          }}
        >
          Page Not Found
        </h2>
        <p
          style={{
            color: 'var(--gray-dim)',
            fontSize: '16px',
            fontFamily: 'DM Sans, sans-serif',
            lineHeight: '1.6',
            marginBottom: '36px',
          }}
        >
          The page you're looking for doesn't exist. Let's get you back.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => router?.push('/')}
            className="btn-primary"
            style={{ fontSize: '13px', padding: '14px 28px', justifyContent: 'center' }}
          >
            Back to Home
          </button>
          <button
            onClick={() => window.history?.back()}
            className="btn-ghost"
            style={{ fontSize: '13px', padding: '14px 28px', justifyContent: 'center' }}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}